import * as React from 'react';
import {BrowserRouter as Router, Route, Switch} from 'react-router-dom';
import FlexeContext, {FlexeContextValues} from '../../contexts/FlexeContext';
import PrintStation from './PrintStation';

interface AppProps {
  authenticityToken: string;
  defaultBarcodes: string;
  printCssUrl: string;
}

function PrintStationApp(props: AppProps) {
  const flexeContextValue: FlexeContextValues = {
    authenticityToken: props.authenticityToken
  };

  return (
    <FlexeContext.Provider value={flexeContextValue}>
      <Router>
        <Switch>
          <Route path="/wh/print_station" exact render={(routeProps) => <PrintStation {...routeProps} {...props} />} />
        </Switch>
      </Router>
    </FlexeContext.Provider>
  );
}

export default PrintStationApp;
